/**
 * Gets the array of elements that match the selector
 * @param {String} selector Selector to find
 */
export function getElementsBySelector(selector) {
  if (Object.prototype.toString.call(selector) === '[object String]') {
    return [...window.document.querySelectorAll(selector)];
  }

  return [];
}

/**
 * Append the desired classes to a particular element
 * @param {Element} element Element to append the class/es
 * @param {String} classes Classes to append
 */
export function addClassToElement(element = {}, classes = '') {
  if (
    element &&
    element.getAttribute &&
    element.setAttribute &&
    Object.prototype.toString.call(classes) === '[object String]' &&
    classes !== ''
  ) {
    let elmClasses = element.getAttribute('class');
    elmClasses = elmClasses ? `${elmClasses} ${classes}` : classes;
    element.setAttribute('class', elmClasses);
  }
}

/**
 * Gets the first HTML element according to the given root element and tag name.
 * @param {Element} el Root element from the tag is going to be grabbed.
 * @param {string} name Name of the tag we want to get.
 */
export function getFirstElementOf(el, name) {
  let element;

  if (
    el &&
    el.tagName &&
    Object.prototype.toString.call(el.tagName) === '[object String]' &&
    name &&
    Object.prototype.toString.call(name) === '[object String]'
  ) {
    const $name = name.toLowerCase();
    const inputs = el.getElementsByTagName($name);
    // eslint-disable-next-line prefer-destructuring
    return inputs[0];
  }

  return element;
}

export function dispatchEvent(el, name) {
  if (
    el &&
    el.dispatchEvent &&
    Object.prototype.toString.call(el.dispatchEvent) === '[object Function]' &&
    name &&
    Object.prototype.toString.call(name) === '[object String]'
  ) {
    // Create the event.
    const event = document.createEvent('Event');
    // Define that the event name is 'build'.
    event.initEvent(name, true, true);

    el.dispatchEvent(event);
  }
}

/**
 * Identify the type of device
 */
export function isMobile() {
  const withinMediaQuery = window.matchMedia('(max-width: 767px)').matches;
  return withinMediaQuery;
}

/**
 * Checks if an element is inside the viewport
 * @param {Element} element
 * @returns {Boolean}
 */
export function isInViewport(element) {
  if (element && element.getBoundingClientRect) {
    const bounding = element.getBoundingClientRect();
    return (
      bounding.bottom >= 0 &&
      bounding.right >= 0 &&
      bounding.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  return false;
}

/**
 * Scroll to a desired element, if the element does not exists, then scrolls to
 * the point (0, 0) of the window
 * @param {String|Element} elementSelector CSS selector to find the element or element to scroll
 */
export function scrollTo(elementSelector = {}, offset = 0) {
  const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
  const element =
    Object.prototype.toString.call(elementSelector) === '[object String]'
      ? document.querySelector(elementSelector) || {}
      : elementSelector;
  const options = {
    behavior: 'smooth',
    left: 0,
    top: 0,
  };

  if (element.getBoundingClientRect) {
    const clientRect = element.getBoundingClientRect();
    const bodyRect = document.body.getBoundingClientRect();
    options.left = clientRect.left || 0;
    options.top = Math.abs((bodyRect.top || 0) - (clientRect.top || 0)) + offset;
  }

  if (isSmoothScrollSupported) {
    window.scrollTo(options);
  } else {
    window.scrollTo(options.left, options.top);
  }
}

/**
 * Sets the component in window.
 * @param {String} propertyName The property name to be set.
 * @param {Object} component The component to be set.
 */
export function setComponent(propertyName, component) {
  if (window && Object.prototype.toString.call(propertyName) === '[object String]') {
    window[propertyName] = component;
  }
}

/**
 * Adds a new script file in the head of document.
 * @param {String} url Url of the script file.
 */
export function addScript(url) {
  if (document) {
    const paymentCallback = document.createElement('script');
    paymentCallback.setAttribute('src', url);
    document.head.appendChild(paymentCallback);
  }
}

const beforeunloadCb = (event) => {
  // Cancel the event
  event.preventDefault();
  const message = 'You have unsaved changes, do you want to continue?';
  // eslint-disable-next-line no-param-reassign
  (event || window.event).returnValue = message;
  return message;
};

/**
 * Sets on demand the on before unload event listener
 * @returns {Function} Listener
 */
export function setBeforeUnload() {
  /* istanbul ignore else */
  if (window.addEventListener) {
    window.addEventListener('beforeunload', beforeunloadCb);
  } else {
    window.onbeforeunload = beforeunloadCb;
  }

  return beforeunloadCb;
}

export function removeBeforeUnload() {
  /* istanbul ignore else */
  if (window.removeEventListener) {
    window.removeEventListener('beforeunload', beforeunloadCb);
  } else {
    window.onbeforeunload = null;
  }
}
